import React from "react";
import { useSelector } from "react-redux";
import { Routes, Route, Navigate } from "react-router-dom";
import InstitutionalRoutes from "./InstitutionalRoutes";

export default function SiteRoutes() {
  const adminAuth = useSelector((state) => state.adminFunction.isAuthenticated);
  const staffAuth = useSelector((state) => state.staffFunction.isAuthenticated);
  const applicantAuth = useSelector(
    (state) => state.applictaionForm.isAuthenticated,
  );
  const studentAuth = useSelector(
    (state) => state.studentFunction.isAuthenticated,
  );
  const studentData = useSelector(
    (state) => state.studentFunction.queue.studentData,
  );

  console.log(studentData);
  const studAdm =
    studentData?.info?.academicInfo?.admission_number ||
    studentData?.info?.admission_number;
  const admAuth = useSelector(
    (state) => state.admissionActions.isAuthenticated,
  );

  return (
    <Routes>
      {InstitutionalRoutes.map((req, res) => {
        if (req.isPublic) {
          return <Route path={req.path} element={req.element} key={res} />;
        } else if (req.isAdmin) {
          return (
            <Route
              path={req.path}
              element={
                adminAuth ? req.element : <Navigate to="/management_login" />
              }
              key={res}
            />
          );
        } else if (req.isStaff) {
          return (
            <Route
              path={req.path}
              element={staffAuth ? req.element : <Navigate to="/staff_login" />}
              key={res}
            />
          );
        } else if (req.isStudent) {
          return (
            <Route
              path={req.path}
              element={
                studentAuth ? req.element : <Navigate to="/student_login" />
              }
              key={res}
            />
          );
        } else if (req.isStudentGuest) {
          return (
            <Route
              path={req.path}
              element={
                studentAuth ? (
                  <Navigate
                    to={`/students/${studentData?.info?._id}/account/${encodeURIComponent(studAdm)}/portal`}
                    replace
                  />
                ) : (
                  req.element
                )
              }
              key={res}
            />
          );
        } else if (req.isApplicants) {
          return (
            <Route
              path={req.path}
              element={
                applicantAuth ? (
                  req.element
                ) : (
                  <Navigate to="/admission_status" />
                )
              }
              key={res}
            />
          );
        } else if (req.isAdmission) {
          return (
            <Route
              path={req.path}
              element={
                admAuth ? req.element : <Navigate to="/admission_status" />
              }
              key={res}
            />
          );
        } else if (req.isPrivate) {
          return (
            <Route
              path={req.path}
              element={admAuth ? req.element : <Navigate to="/" />}
              key={res}
            />
          );
        } else if (req.isPrivate) {
          return (
            <Route
              path={req.path}
              element={staffAuth ? req.element : <Navigate to="/" />}
              key={res}
            />
          );
        } else if (req.isPrivate) {
          return (
            <Route
              path={req.path}
              element={studentAuth ? req.element : <Navigate to="/" />}
              key={res}
            />
          );
        } else return false;
      })}
    </Routes>
  );
}
